import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { chevronDown } from '@primeicons/core/chevron-down';

@Component({
    selector: 'svg[data-p-icon="chevron-down"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class ChevronDown extends CoreIcon {
    constructor() {
        super();
        this._icon = chevronDown;
    }
}
